import tribunalAPI, { electronicoAPI } from "../../api/tribunalAPi";
import {
  ResponseCarpetaJudicial,
  ResponseInstancias,
  ResponseInstanciasOficialia,
  ResponseJuzgados,
  ResponseJuzgadosElectronico,
  ResponseJuzgadosAutorizados,
  ResponseMaterias,
  ResponseMateriasInstancias,
  ResponseMateriasOficialia,
  ResponseTiposCarpetas,
  SolicitudCarpetaJudicial,
  SolicitudJuzgadosOrdinariosEnLinea,
} from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { JuzgadosConExpedienteResponse } from "interfaces/juzgadosConExpediente/juzgadosConExpedinte";

const getJuzgadosService = async () => {
  let url = "/servicios-generales/obtener/juzgados";
  return await tribunalAPI.get<ResponseJuzgados>(url);
};

const getJuzgadosAutorizadosService = async () => {
  let url = "/reporte-tribunal/obtener/juzgados";
  return await tribunalAPI.get<ResponseJuzgadosAutorizados>(url);
};

const getMateriasOrdinariasEnLinea = async (enLinea: string) => {
  let url = `promociones/obtener/materias-ordinarias-en-linea?enLinea=${enLinea}`;
  return await tribunalAPI.get<ResponseMaterias>(url);
};

const getInstanciasOrdinariasEnLinea = async (enLinea: string) => {
  let url = `/promociones/obtener/instancias-ordinarias-en-linea?enLinea=${enLinea}`;
  return await tribunalAPI.get<ResponseInstancias>(url);
};

const getTiposNumeros = async (cveMateria: number) => {
  let url = `/servicios-generales/obtener/tipos-carpetas?cveMateria=${cveMateria}`;
  return await tribunalAPI.get<ResponseTiposCarpetas>(url);
};

const getJuzgadosExpediente = async () => {
  let url = `/servicios-generales/obtener/juzgados-electronico`;
  return await tribunalAPI.get<ResponseJuzgadosElectronico>(url);
};

const getMateriaOficialia = async (cveOficialia: number) => {
  let url = `/demandas/obtener/materias/${cveOficialia}`;
  return await tribunalAPI.get<ResponseMateriasOficialia>(url);
};

const getInstanciaOficialia = async (
  cveOficialia: number,
  cveMateria: number
) => {
  let url = `/demandas/obtener/instancias/${cveOficialia}?${cveMateria}`;
  return await tribunalAPI.get<ResponseInstanciasOficialia>(url);
};

const getJuzgadosOrdinariosEnLinea = async (
  body: SolicitudJuzgadosOrdinariosEnLinea
) => {
  let url = `/promociones/obtener/juzgados-ordinarias-en-linea`;
  return await tribunalAPI.get<ResponseMaterias>(url, {
    params: {
      cveMateria: body?.cveMateria,
      enLinea: body?.enLinea,
      tipoPenal: body?.tipoPenal,
    },
  });
};

const getCarpetaJudicial = async (body: SolicitudCarpetaJudicial) => {
  let url = `/servicios-generales/obtener/carpeta-judicial`;
  return await tribunalAPI.get<ResponseCarpetaJudicial>(url, {
    params: body,
  });
};

const getMateriasInstancias = async (cveAds: number) => {
  let url = `/servicios-generales/obtener/materias-instancias?cveAdscripcion=${cveAds}`;
  return await tribunalAPI.get<ResponseMateriasInstancias>(url);
};

const getJuzgadosIndicesService = async () => {
  let url = `/indices/juzgados`;
  return await tribunalAPI.get<JuzgadosConExpedienteResponse>(url);
};

const getFile = async (idImagen: number) => {
  let url = `/carga-imagenes/obtener-imagen?idImagen=${idImagen}`;
  return await tribunalAPI.get(url, {
    responseType: "arraybuffer",
  });
};

const getFechasLiberacionJuiciosVigentes = async () => {
  let url = "servicios-generales/obtener/fechas/liberacion-juiciosVigentes";
  return await tribunalAPI.get(url);
};

const getVideoTutorialActivo = async () => {
  let url = "servicios-generales/obtener/avisos-tribunal";
  return await tribunalAPI.get(url);
};

const getDocumentosCentralesService = async (idActuacion: number) => {
  let url = `notificaciones/mercantilesV2/obtenerDocumentosCentrales?idActuacion=${idActuacion}`;
  return await electronicoAPI.get(url, {
    responseType: "arraybuffer",
  });
};
const getDocumentosCentralesServiceNoBuffer = async (idActuacion: number) => {
  let url = `notificaciones/mercantilesV2/obtenerDocumentosCentrales?idActuacion=${idActuacion}`;
  return await electronicoAPI.get(url);
};

export {
  getTiposNumeros,
  getCarpetaJudicial,
  getJuzgadosService,
  getJuzgadosAutorizadosService,
  getMateriaOficialia,
  getInstanciaOficialia,
  getMateriasInstancias,
  getMateriasOrdinariasEnLinea,
  getJuzgadosOrdinariosEnLinea,
  getInstanciasOrdinariasEnLinea,
  getJuzgadosIndicesService,
  getFile,
  getFechasLiberacionJuiciosVigentes,
  getVideoTutorialActivo,
  getJuzgadosExpediente,
  getDocumentosCentralesService,
  getDocumentosCentralesServiceNoBuffer,
};
